<template>
    <span class="icon icon_info">
        <svg
            class="on"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M3 5C3 3.89543 3.89543 3 5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5Z"
                :fill="color"/>
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M19 4.5H5C4.72386 4.5 4.5 4.72386 4.5 5V19C4.5 19.2761 4.72386 19.5 5 19.5H19C19.2761 19.5 19.5 19.2761 19.5 19V5C19.5 4.72386 19.2761 4.5 19 4.5ZM5 3C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3H5Z"
                  :fill="color"/>

        </svg>
        <svg
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="off"
        >
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M19 4.5H5C4.72386 4.5 4.5 4.72386 4.5 5V19C4.5 19.2761 4.72386 19.5 5 19.5H19C19.2761 19.5 19.5 19.2761 19.5 19V5C19.5 4.72386 19.2761 4.5 19 4.5ZM5 3C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3H5Z"
                  :fill="color"/>

        </svg>
    </span>
</template>

<script lang="ts">
export default {
    name: 'IconCheckSquareEmpty',
    props: {
        color: {
            type: String,
            default: '#1a1a1a',
        },
    },
};
</script>

<style scoped lang="scss">
.icon_info {
    display: inline-block;
    vertical-align: middle;
    font-size: 0;
    width: 24px;
    height: 24px;

    svg {
        width: 100%;
        height: 100%;
    }

    &.on {
        .on {
            display: block;
        }

        .off {
            display: none;
        }
    }

    &:not(.on) {
        .on {
            display: none;
        }

        .off {
            display: block;
        }
    }
}
</style>
